export default __webpack_public_path__ + "images/d7976f20b56d6110cc487fe3cbb5e790-hiking.jpg";